module.exports = __webpack_public_path__ + "img/Rectangle 33.59d2bfba.png";